import { render } from "./PublicPledgeMaking.vue?vue&type=template&id=6c48294d&scoped=true"
import script from "./PublicPledgeMaking.vue?vue&type=script&lang=js"
export * from "./PublicPledgeMaking.vue?vue&type=script&lang=js"

import "./PublicPledgeMaking.vue?vue&type=style&index=0&id=6c48294d&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c48294d"]])

export default __exports__